export const buildBookingUrl = ({
  baseUrl,
  registration,
  centerId,
  nafCenterProductType,
}: {
  baseUrl: string;
  registration: string;
  centerId?: string | number;
  nafCenterProductType: 'service' | 'repairment';
}): string => {
  const params = new URLSearchParams();

  if (registration) {
    params.set('registration', registration);
  }

  if (centerId) {
    params.set('centerId', String(centerId));
  }

  params.set('type', nafCenterProductType);

  return `${baseUrl}${params.toString()}`;
};

export const VehicleTypesToShow = ['Car', 'Truck', 'TruckNoCargo', 'Van'];
